export const usePasswordValidator = (password: string) => {
  let hasSpecialCharacters = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
  let hasLowercase = /^(?=.*[a-z])/
  let hasUppercase = /^(?=.*[A-Z])/
  let error = ''

  if (!hasLowercase.test(password)) {
    error = 'Password must contain at least one lowercase letter'
  }

  if (!hasUppercase.test(password)) {
    error = 'Password must contain at least one uppercase letter'
  }
  if (!hasSpecialCharacters.test(password)) {
    error = 'Must contain at least one special character'
  }

  if (password.length < 8) {
    error = 'Password must be at least 8 characters long'
  }

  return error
}
